import React from 'react'

import EmptyResults from '@cinch/oxd-components/empty-results/src'
import { OurCommitmentSlim } from '@cinch/oxd-components/our-commitment/src'
import ListingVehicle from '@cinch/oxd-containers/dealer-listing-vehicle/src'
import Pagination from '@cinch/oxd-containers/dealer-vehicle-results-pagination/src'
import PendingProduct from './components/pending-product.component'
import { PropsFromState } from './listing-results.container'

import * as styles from './listing-results.module.css'

export interface ListingResultsProps extends PropsFromState {
  className?: string
  i18n: Pick<Cinch.WebAppTranslations['findVehicle'], 'fuelFinder' | 'noResults'>
}

const Component: React.FC<ListingResultsProps> = ({
  results,
  isDelivery,
  isPending,
  isFetchComplete,
  activePage,
  className = '',
  i18n,
}) => {
  const isLoading = isPending && !results.length
  const hasCommitment = activePage === 1 && results.length > 4

  return (
    <div className={className}>
      <div className={styles.list}>
        {isLoading &&
          Array.from(Array(2)).map((_v, ind) => (
            <div className={styles.item} key={ind}>
              <PendingProduct />
            </div>
          ))}

        {!results.length && isFetchComplete && (
          <div className={styles.emptyResultsContainer}>
            <EmptyResults body={isDelivery ? i18n.noResults.withDelivery : i18n.noResults.withoutDelivery} />
          </div>
        )}

        {results.map((vehicleId, index) => {
          const vehicle = (
            <div className={styles.item} key={vehicleId}>
              <ListingVehicle className={styles.vehicle} id={vehicleId} hasCompareButton={true} />
            </div>
          )
          if (!hasCommitment || index !== 3) {
            return vehicle
          } else {
            return (
              <React.Fragment key={vehicleId}>
                {vehicle}
                <div key={'commitment'} data-testid="commitment" className={styles.commitment}>
                  <OurCommitmentSlim targetBlank={true} />
                </div>
              </React.Fragment>
            )
          }
        })}
      </div>
      {!!results.length && <Pagination />}
    </div>
  )
}

export default Component
